import styles from './footer.module.scss';
import { useNavigate } from 'react-router-dom'
import qrCode1Png from '../assets/images/qrCode1.png';
import qrCode2Png from '../assets/images/qrCode2.png';
import qrCode3Png from '../assets/images/qrCode3.png';
import { getLangName as t } from '../utils/index'

function Footer() {
    const navigate = useNavigate();
    const handleNavi = (path) => {
        navigate(path);
    }
    return (
        <>
            <div className={styles.footer_info}>
                <div className={styles.info_tab}>
                    <div className={styles.tab_item} onClick={() => handleNavi('/')}>{t('home')}</div>
                    <div className={styles.tab_item}>{t('product')}</div>
                    <div className={styles.tab_item} onClick={() => handleNavi('/settings')}>{t('case')}</div>
                    <div className={styles.tab_item} onClick={() => handleNavi('/contactUs')}>{t('contact')}</div>
                </div>
                <div className={styles.info_box}>
                    <div className={styles.info_box_left}>
                        <div>
                            <h2>深圳市泰科佳科技有限公司</h2>
                            <span>{t('Phone')}: 18118700596/18739767975</span>
                        </div>
                    </div>
                    <div className={styles.info_box_right}>
                        <div>
                            <img src={qrCode1Png} />
                        </div>
                        <div>
                            <img src={qrCode2Png} />
                        </div>
                        <div>
                            <img src={qrCode3Png} />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.footer}>
                <p>Copyright &copy; 2023</p>
            </div> */}
        </>
    )
}

export default Footer;